/**
 * Array of Formula pages.
 */
export interface IFormulaProps {
  name: string;
  path: string;
  id: number;
  section?: string;
  compute?: string | ((...args: any[]) => any);
  noNvalue?: boolean;
}
export const formulaSphereCompute = (formData)=>{
  // guard the function from "read property of undefine" error
  
  if (!formData || typeof formData.diameter !== 'string') {
    return
  }
  const diameter = parseFloat(formData.diameter);
  const surfaceArea = Math.PI * diameter * diameter;
  const volume = (1 / 6) * Math.PI * Math.pow(diameter, 3);
  const result = {
    surfaceArea: surfaceArea,
    volume: volume,
    errorResponse: null,
    validationPass: true
  }
  return result;
}

export const formulaRectangularParallelepiped=(formData)=>{
  // guard the function from "read property of undefine" error
  if (
    !formData || 
    typeof formData.sideA !== 'string' || 
    typeof formData.sideB !== 'string' || 
    typeof formData.sideC !== 'string'
  ) {
    return
  }
  const sideA =  parseFloat(formData.sideA);
  const sideB =  parseFloat(formData.sideB);
  const sideC =  parseFloat(formData.sideC);
  const volume = sideA*sideB*sideC;
  const area = 2*(sideA*sideB +sideA*sideC+sideB*sideC);
  const diagonal = Math.sqrt(sideA*sideA + sideB*sideB + sideC*sideC);
  const result = {
    volume: volume,
    area: area,
    diagonal: diagonal,
    errorResponse: null,
    validationPass: true
  }
  return result;
}

export const formulaList1: IFormulaProps[] = [
  {
    name: 'Trapezoid Channel',
    path: 'trapezoidal-channel',
    id: 10,
    section: 'Hydraulic Structures',
    compute: 'calculateTrapezoidalChannelUsingPOST',
  },
  {
    name: 'Box Inlet Drop',
    path: 'box-inlet-drop',
    id: 1,
    section: 'Hydraulic Structures',
    compute: 'calculateBoxDropInletUsingPOST',
  },
  {
    name: 'Hooded Inlet',
    path: 'hooded-inlet',
    id: 3,
    section: 'Hydraulic Structures',
    compute: 'calculateHoodedInletResultsUsingPOST',
  },
  {
    name: 'Pipe Drop',
    path: 'pipe-drop',
    id: 5,
    section: 'Hydraulic Structures',
    compute: 'calculatePipeDropUsingPOST',
  },
  {
    name: 'Plunge Pool',
    path: 'plunge-pool',
    id: 6,
    section: 'Hydraulic Structures',
    compute: 'calculatePlungePoolUsingPOST',
  },
  {
    name: 'Rectangular Riser Drop',
    path: 'rectangular-riser-drop',
    id: 8,
    section: 'Hydraulic Structures',
    compute: 'calculateRectRiserDropResultsUsingPOST',
  },
  {
    name: 'Parabolic Channel',
    path: 'parabolic-channel',
    id: 4,
    section: 'Hydraulic Structures',
    compute: 'calculateParabolicChannelUsingPOST',
  },
  {
    name: 'Straight Drop Inlet',
    path: 'straight-drop-inlet',
    id: 9,
    section: 'Hydraulic Structures',
    compute: 'calculateStraightDropInletResultsUsingPOST',
  },
  {
    name: 'Water Control',
    path: 'water-control',
    id: 11,
    section: 'Hydraulic Structures',
    compute: 'calculateInlineWaterUsingPOST',
  },
  {
    name: 'Dry Hydrant',
    path: 'dry-hydrant',
    id: 2,
    section: 'Hydraulic Structures',
    compute: 'calculateDryHydrantUsingPOST',
  },
  {
    name: 'Circular Section',
    path: 'circular-section',
    id: 12,
    section: 'Miscellaneous Hydraulic',
    compute: 'calGravityFlowInCircularSectionUsingPOST',
    noNvalue: true,
  },
  {
    name: 'Orifice Flow',
    path: 'orifice-flow',
    id: 13,
    section: 'Miscellaneous Hydraulic',
    compute: 'calculateOrificeFlowUsingPOST',
    noNvalue: true,
  },
  {
    name: 'Pressure Flow in Pipe',
    path: 'pressure-flow-in-pipe',
    id: 14,
    section: 'Miscellaneous Hydraulic',
    compute: 'calculatePressureFlowPipeUsingPOST',
  },
  { name: 'Pipe Flow Formula', path: 'pipe-flow-formula', id: 0, section: 'Miscellaneous Hydraulic' },
  {
    name: 'Weir Flow',
    path: 'weir-flow',
    id: 16,
    section: 'Weir Flow',
    compute: 'calculateWeirFlowUsingPOST',
    noNvalue: true,
  },
  {
    name: 'V-Notch Weir',
    path: 'vnotch-weir',
    id: 15,
    section: 'Weir Flow',
    compute: 'calVNotchWeirFlowUsingPOST',
    noNvalue: true,
  },
];

export const formulaList2: IFormulaProps[] = [
  // { name: 'Equilateral Triangle', path: 'equilateral-triangle', id: 0, section: 'Plane Form' },
  // { name: 'Oblique Triangle', path: 'oblique-triangle', id: 0, section: 'Plane Form' },
  { name: 'Parabola', path: 'parabola', id: 20, section: 'Plane Form', noNvalue: true , compute: 'calculateParabolaUsingPOST' },
  { name: 'Parallelogram', path: 'parallelogram', id: 21, section: 'Plane Form', noNvalue: true , compute: 'calculateParallelogramUsingPOST' },
  { name: 'Rectangular', path: 'rectangular', id: 0, section: 'Plane Form' },
  { name: 'Circle', path: 'circle', id: 17, section: 'Plane Form', noNvalue : true , compute: 'calculateCircleUsingPOST'},
  // { name: 'Cube', path: 'cube', id: 0, section: 'Solid Forms' },
  { name: 'Frustrum of a Cone', path: 'frustum-cone', id: 24, section: 'Solid Forms', noNvalue: true , compute: 'calculateConeUsingPOST' },
  { name: 'Frustrum of Pyramid', path: 'frustum-pyramid', id: 25, section: 'Solid Forms',noNvalue: true, compute:'calculateFrustrumPyramidUsingPOST' },
  { name: 'Prismatoid', path: 'prismatoid', id: 26, section: 'Solid Forms',noNvalue: true , compute: 'calculatePrismatoidUsingPOST'},
  { name: 'Rectangular Parallelepiped', path: 'rectangular-parallelepiped', id: 27, section: 'Solid Forms', noNvalue: true, compute:formulaRectangularParallelepiped },
  { name: 'Sphere', path: 'sphere', id: 28, noNvalue: true, section: 'Solid Forms', compute:formulaSphereCompute },
  // {
  //   name: 'Pump Drainage',
  //   path: 'pump-drainage',
  //   id: 7,
  //   section: 'Drainage',
  //   compute: 'calculatePumpDrainageUsingPOST',
  // },
  // {
  //   name: 'Subsurface Drainage',
  //   path: 'subsurface-drainage',
  //   id: 0,
  //   section: 'Drainage',
  //   compute: 'calculateSubsurfaceDrainageUsingPOST',
  // },
  // {
  //   name: 'Surface Inlet',
  //   path: 'surface-inlet',
  //   id: 0,
  //   section: 'Drainage',
  //   compute: 'calculateSurfaceInletUsingPOST',
  // },
];

